import { FileText, Users, Calendar, DollarSign, Mail, Phone, Globe, Building } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { EntityType } from '../types';

export const entityColors: Record<EntityType, string> = {
  PERSON: 'bg-blue-50 border-blue-200 hover:bg-blue-100',
  ORG: 'bg-green-50 border-green-200 hover:bg-green-100',
  DATE: 'bg-yellow-50 border-yellow-200 hover:bg-yellow-100',
  MONETARY: 'bg-purple-50 border-purple-200 hover:bg-purple-100',
  PERSON_TITLE: 'bg-pink-50 border-pink-200 hover:bg-pink-100',
  EMAIL: 'bg-orange-50 border-orange-200 hover:bg-orange-100',
  PHONE: 'bg-teal-50 border-teal-200 hover:bg-teal-100',
  GPE: 'bg-red-50 border-red-200 hover:bg-red-100',
  LOC: 'bg-indigo-50 border-indigo-200 hover:bg-indigo-100',
  URL: 'bg-cyan-50 border-cyan-200 hover:bg-cyan-100',
  ORGANIZATION: 'bg-emerald-50 border-emerald-200 hover:bg-emerald-100',
  default: 'bg-gray-50 border-gray-200 hover:bg-gray-100'
};

export const entityIcons: Record<EntityType, LucideIcon> = {
  PERSON: Users,
  ORG: Building,
  DATE: Calendar,
  MONETARY: DollarSign,
  EMAIL: Mail,
  PHONE: Phone,
  URL: Globe,
  ORGANIZATION: Building,
  PERSON_TITLE: Users,
  GPE: Globe,
  LOC: Globe,
  default: FileText
};

export const getConfidenceColor = (confidence: number): string => {
  if (confidence > 0.9) return 'text-green-600';
  if (confidence > 0.7) return 'text-yellow-600';
  return 'text-red-600';
};

export const getConfidenceBarColor = (confidence: number): string => {
  if (confidence > 0.9) return 'bg-green-500';
  if (confidence > 0.7) return 'bg-yellow-500';
  return 'bg-red-500';
};

export const getConfidenceText = (confidence: number): string => {
  if (confidence > 0.9) return 'High confidence';
  if (confidence > 0.7) return 'Medium confidence';
  return 'Low confidence';
};